/** Query param: base workout id to highlight on programme overview (e.g. from Keep going). */
export const HIGHLIGHT_WORKOUT_QUERY_PARAM = 'highlightWorkout'

/** sessionStorage key: next workout to highlight after completing a class (read on programme overview mount). */
export const PROGRAMME_OVERVIEW_PENDING_HIGHLIGHT_SESSION_KEY = 'grndhouse.programmeOverview.pendingHighlight'
